module.exports = __webpack_public_path__ + "assets/img/默认头像0.8bd6e0e1.png";